import {EpLayer} from "./layer";
import {zonesStyle} from "../styles/zones";
import {createFeatureFromCoordinates} from "../utilities";


export class EpZonesLayer extends EpLayer {
    constructor(map) {
        super(map);

        this.style = zonesStyle;
        this.farStyle = zonesStyle;
        this.title = 'Ograniczenia';
        this.name = 'zones';

        return this;
    }

    addToMapFromCoordinates(coordinates, options) {
        options = {...{ resize: true }, ...options};

        let feature = createFeatureFromCoordinates(coordinates)
        feature.setId(options.id);
        feature.set('name', options.name);
        feature.set('type', options.type);
        feature.set('zoomLimit', 13);
        this.getSource().addFeature(feature);

        if(options.resize) {
            this.fitInView();
        }
    }

    addZonesFromObject(zones, options = {}) {
        for(let zone of zones) {
            this.addFeature(zone.coordinates, {
                resize: options.resize ?? false,
                fields: {
                    zoomLimit: 13,
                    id: zone.id,
                    name: zone.name,
                    'zone-data': zone,
                    type: 'zone'
                }
            });
        }
    }



}
